import React from 'react';

import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import { applyTestIdData } from 'Utilities/helpers';

import styles from './VehicleCardV2.module.scss';

export const VehicleCardV2Skeleton: React.FC = () => (
	<li aria-busy="true" className={styles.card} {...applyTestIdData('vehicle-card-v2-skeleton')}>
		<div className={styles.article}>
			<div className={styles.imageWrapper}>
				<div className={styles.imageArea}>
					<Skeleton isFullWidth className={styles.skeletonImage} />
				</div>
			</div>
			<div className={styles.heading}>
				<span className={styles.make}>
					<Skeleton height={2} width={8} />
				</span>
				<span className={styles.model}>
					<Skeleton height={3} width={14} />
				</span>
			</div>
			<div className={styles.specs}>
				<Skeleton height={2} width={18} />
			</div>
			<div className={styles.priceRow}>
				<Skeleton height={3} width={10} />
			</div>
			<div className={styles.attributes}>
				<Skeleton height={2} width={6} />
				<Skeleton height={2} width={8} />
			</div>
		</div>
	</li>
);
